/** Warm TLS/DNS for app links so Sign Up / Log In feel instant from the marketing site. */
export function warmAppNavigationLinks(
  appUrl: string,
  paths: string[] = ['/signup', '/login'],
): void {
  if (typeof document === 'undefined') return;

  const base = appUrl.replace(/\/$/, '');
  const hrefs = paths.map((path) => `${base}${path}`);

  for (const href of hrefs) {
    if (document.head.querySelector(`link[data-ww-prefetch="${href}"]`)) {
      continue;
    }
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    link.setAttribute('data-ww-prefetch', href);
    document.head.appendChild(link);
  }
}
